import { ArrowRightIcon } from "@primer/octicons-react";
import { Box } from "@primer/react";
import { useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { appConst } from "../AppConst";
import BrandLogo from "../components-ui/brand-logo";
import Button from "../components-ui/button";
import LoaderPage from "../components-ui/loader-page";
import Text from "../components-ui/text";
import { useAppDispatch } from "../hooks/useAppDispatch";
import { rootActions } from "../state/actions/rootActions";
import { useAppSelector } from "../hooks/useAppSelector";

const LoginOidcPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {status, user} =useAppSelector(x=>x.auth);
  const query = new URLSearchParams(location.search);
  const code = query.get("code");
  const state = query.get("state");
  const session_state = query.get("session_state");

  const pkceChallengeFromVerifier = async (verifier: string) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await window.crypto.subtle.digest("SHA-256", data);
    return btoa(String.fromCharCode(...new Uint8Array(digest)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  const generateRandomString = (length = 64) => {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return result;
  };

  useEffect(() => {
    const runAuthFlow = async () => {

      const code_verifier = sessionStorage.getItem("code_verifier") ?? "";
      if (code && state && session_state && code_verifier) {
        if (user) return;
        // Mã code của OIDC chỉ dùng được 1 lần. Nếu code này đã được gửi đi rồi
        // (component bị mount lại sau khi login lỗi) thì không gọi lại login-vnpt
        // nữa, mà dọn dẹp và quay về trang đăng nhập để lấy code mới.
        if (sessionStorage.getItem("login_vnpt_code") === code) {
          sessionStorage.removeItem("login_vnpt_code");
          sessionStorage.removeItem("code_verifier");
          sessionStorage.removeItem("oauth_state");
          navigate("/login", { replace: true });
          return;
        }
        sessionStorage.setItem("login_vnpt_code", code);

        dispatch(
          rootActions.auth.LOGIN_VNPT_START({
            code,
            state,
            session_state,
            code_verifier,
          })
        );
      } else {
        
        if(user) return;
        const state = generateRandomString();
        const codeVerifier = generateRandomString(64);
        const codeChallenge = await pkceChallengeFromVerifier(codeVerifier);
        const authUrl = `${
          appConst.OIDC_AUTHORITY
        }?response_type=code&client_id=${
          appConst.OIDC_CLIENT_ID
        }&redirect_uri=${encodeURIComponent(
          appConst.OIDC_REDIRECT_URI
        )}&scope=${encodeURIComponent(
          appConst.OIDC_SCOPE
        )}&state=${state}&code_challenge=${codeChallenge}&code_challenge_method=S256`;
        sessionStorage.setItem("code_verifier", codeVerifier);
        sessionStorage.setItem("oauth_state", state);
        
        window.location.href = authUrl;
      }
    };
if(!user)
    runAuthFlow();
  }, [code, dispatch, navigate, session_state, state, user]);

  return <LoaderPage />;
};

const LogoutPage = () => {
  return <LoaderPage />;
};
const LoginForm = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: "rgba(255,255,255,0.9)",
        backdropFilter: "blur(2rem)",
        width: 400,
        p: 4,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          mb: 3,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Text
            text="Đăng nhập"
            sx={{
              fontSize: 20,
              fontWeight: "bolder",
            }}
          />
          <Text
            text="Xác thực bằng cổng đăng nhập tập trung"
            sx={{
              color: "fg.muted",
              mb: 2,
            }}
          />
        </Box>

        <BrandLogo height={64} />
      </Box>
      <Box>
        <Button
          text="Tiếp tục"
          variant="primary"
          onClick={() => {
            navigate(`../../signin-oidc`);
          }}
          trailingVisual={ArrowRightIcon}
          block
          size="medium"
          sx={{
            mb: 2,
          }}
        />
      </Box>
    </Box>
  );
};
const OidcContent = () => {
  return (
    <Routes>
      <Route path={`/signin-oidc`} Component={LoginOidcPage} />
      <Route path={`/signout-oidc`} Component={LogoutPage} />
      <Route path="*" element={<Navigate to={"/login"} replace />} />
    </Routes>
  );
};
const UnAuthorizedContentVNPT = () => {
  return (
    <Box
      sx={{
        backgroundImage: "url(../../../images/background.png)",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        minHeight: window.innerHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Routes>
        <Route path={`/login`} Component={LoginForm} />
        <Route path="*" Component={OidcContent} />
      </Routes>
    </Box>
  );
};

export default UnAuthorizedContentVNPT;
